export default class WorldMapInterop {

  Init = async function (wrapperId, svgUrl) {
    const resp = await fetch(svgUrl, { cache: "force-cache" });
    if (!resp.ok) {
      console.error("Failed to load SVG:", resp.status, resp.statusText);
      return;
    }
    const svgText = await resp.text();

    const wrapper = document.getElementById(wrapperId);

    if (!wrapper)
      return;

    wrapper.innerHTML = svgText;

    const svg = wrapper.querySelector("svg");
    const countries = svg.querySelectorAll("path, [id]");

    countries.forEach(country => {
      // configure hover/click

      const countryCode = country.getAttribute("id");
      const countryName = country.getAttribute("title");

      if (countryName) {
        const titleElement = document.createElementNS("http://www.w3.org/2000/svg", "title");
        titleElement.textContent = countryName;
        country.appendChild(titleElement);
      }
    })
  }

  SetColors = function (wrapperId, countryCodes, colors) {
    const wrapper = document.getElementById(wrapperId);
    if (!wrapper)
      return;
    
    const svg = wrapper.querySelector("svg");

    if (!svg)
      return;

    svg.querySelectorAll('path').forEach(path => {
      path.style.fill = 'inherit';
    })

    countryCodes.forEach((code, index) => {
      const color = colors[index];
      const countryPath = svg.querySelector(`path[id="${code}"]`);
      if (countryPath) {
        countryPath.style.fill = color;
      }
    })
  }

  SetValues = function (wrapperId, countryCodes, values) {
    const wrapper = document.getElementById(wrapperId);
    if (!wrapper)
      return;

    const svg = wrapper.querySelector("svg");

    if (!svg)
      return;

    countryCodes.forEach((code, index) => {
      const value = values[index];
      const countryPath = svg.querySelector(`path[id="${code}"]`);
      if (countryPath) {
        const title = countryPath.querySelector("title");
        const name = countryPath.getAttribute("title");
        title.textContent = value ? `${name} - ${value}` : name;
      }
    });
  }
}
